import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, FontWeight, Media } from '../../theme';
import { styleWhenTrue } from '../../utils';

import { ArrowContainerData } from './productsSliderSection.types';

export const ProductBox = styled.div`
    width: 100%;
  a {
    padding: 35px 30px;
    background-color: ${Color.white};
    text-decoration: none;
    height: 400px;
    display: flex;
    flex-direction: column;
    border: 1px solid ${Color.mediumLightGrey};
  }
`;

export const ProductHeader = styled.div``;

export const Header = styled.div`
  color: ${Color.darkGrey};
  font-size: 25px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 28px;
  padding-bottom: 10px;
  text-decoration: none;
`;

export const Description = styled.div`
  font-size: 12px;
  font-weight: ${FontWeight.Bold};
  letter-spacing: 1.09px;
  line-height: 15px;
  color: ${Color.primary};
  text-transform: uppercase;
  text-decoration: none;
`;

export const ProductPhoto = styled.img`
  max-width: 100%;
  max-height: 210px;
  padding: 50px 0 15px;
  margin: 0 auto;
`;


export const ArrowContainer = styled.button<ArrowContainerData>`
  position: absolute;
  left: -32px;
  top: 50%;
  transform: translateY(-50%);
  height: 64px;
  width: 64px;
  background-color: ${Color.primary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 2;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.7s;
  ${Media.tablet`
    display: none;
  `}
  ${styleWhenTrue(prop('isVisible'), css`
    opacity: 1;
    pointer-events: initial;
  `)}
`;

export const LeftArrowContainer = styled(ArrowContainer)``;

export const RightArrowContainer = styled(ArrowContainer)`
  left: auto;
  right: -32px;
`;

export const LeftArrow = styled.img`
  width: 20px;
`;

export const RightArrow = styled.img`
  width: 20px;
  transform: rotate(180deg);
`;

export const SliderContainer = styled.div`
  position: relative;
`;

export const ComparisonSection = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 30px;
  background-color: ${Color.primary};
  color: ${Color.white};
  cursor: pointer;
  &:disabled {
    background-color: ${Color.veryLightGrey} !important;
  }
`;
